import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';

import { formatLocationListToShortStr } from '@/utils/common';
import { getI18n } from '@/utils/i18n';

import styles from './JobHeader.cm.styl';

const i18n = getI18n();

class JobHeader extends React.Component {
  render() {
    const { job, companyName, headhunterJobFields } = this.props;
    const { title, commitment, publishedAt, prior, locations } = job;
    const status = [];

    const departmentName = get(job, 'department.name') || job.departmentName;
    if (headhunterJobFields.department && departmentName && departmentName !== '未分配部门') {
      status.push(departmentName);
    }

    if (headhunterJobFields.commitment && commitment) {
      status.push(i18n._(commitment));
    }

    const zhinengName = get(job, 'zhineng.name') || job.zhinengName;
    if (headhunterJobFields.zhineng && zhinengName && zhinengName !== '其它') {
      status.push(zhinengName);
    }

    if (headhunterJobFields.location && locations && locations.length) {
      status.push(formatLocationListToShortStr(locations));
    }

    return (
      <div className={styles.heading}>
        <div className={styles.companyName}>{companyName}</div>
        <div className={styles.jobInfo}>
          <div className={styles.title}>
            {!!prior && <span className={styles.highLight}>{i18n.t`[优先]`} </span>}
            {title}
          </div>
          <div className={styles.status}>
            {status.map((item) => (
              <span key={item} className={styles.statusItem}>
                {item}
              </span>
            ))}
            {!!publishedAt && (
              <span className={styles.openedAt}>
                {i18n.t`发布时间：`}
                {moment(publishedAt).format('YYYY-MM-DD')}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

JobHeader.defaultProps = {
  companyName: '',
};

JobHeader.propTypes = {
  job: PropTypes.object.isRequired,
  companyName: PropTypes.string,
};

export default JobHeader;
